import apiClient from './index';
import { ResidentialComplexRead, ResidentialComplexCreate, ResidentialComplexUpdate } from './types';

export const residentialComplexesApi = {
  async getResidentialComplexes(skip: number = 0, limit: number = 100): Promise<ResidentialComplexRead[]> {
    const response = await apiClient.get<ResidentialComplexRead[]>('/residential-complexes/with-details', {
      params: { skip, limit },
    });
    return response.data;
  },

  async createResidentialComplex(data: ResidentialComplexCreate): Promise<ResidentialComplexRead> {
    const response = await apiClient.post<ResidentialComplexRead>('/residential-complexes/', data);
    return response.data;
  },

  async getResidentialComplexById(complexId: string): Promise<ResidentialComplexRead> {
    const response = await apiClient.get<ResidentialComplexRead>(`/residential-complexes/${complexId}`);
    return response.data;
  },

  async updateResidentialComplex(complexId: string, data: ResidentialComplexUpdate): Promise<ResidentialComplexRead> {
    const response = await apiClient.put<ResidentialComplexRead>(`/residential-complexes/${complexId}`, data);
    return response.data;
  },

  async deleteResidentialComplex(complexId: string, force: boolean = false): Promise<void> {
    await apiClient.delete(`/residential-complexes/${complexId}`, {
      params: force ? { force: true } : undefined,
    });
  },
}; 
